@if (thumbnails.length > 0) {
  <div class="text-div">
    @for (thumbnail of thumbnails; track thumbnail) {
      <div>
        <div style="position: relative;">
          @if (thumbnail.image) {
            <div class="thumbnail-container">
              <div style="width: 100%; display: flex; justify-content: center;">
                <img class="thumbnail" [src]="thumbnail.image" [alt]="thumbnail.name" style="max-width: 500px;" data-pdfmake='{"widths": [100, "*", "auto"], "heights": 40}'>
              </div>
              <div class="thumbnail-form"
                [class.no-caption]="!(thumbnail?.caption || '').trim()"
                >
                <span class="caption-text"><i>{{ thumbnail.caption }}</i></span>
                <button class="edit-report" (click)="viewFullSizedImage($event, thumbnail)">
                  View full size image
                  <fa-icon class="fa-sm" [icon]="faExternalLink"></fa-icon>
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
